module.exports = __webpack_public_path__ + "static/media/China-sunset.5dd9845c.svg";